<template>
  <div class="parking-data">
    <div class="parking-data__description" v-html="descriptionTop"></div>
      <div
        :class="hasSpots">
        <div class="parking-data__table">
          <table>
            <thead>
              <tr>
                <th>Kategoria miejsc</th>
                <th>Wszystkie miejsca</th>
                <th>Zajęte miejsca</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{category ? category : this.noData}}</td>
                <td>{{parkingSpots ? parkingSpots : this.noData}}</td>
                <td>{{lastStatus ? lastStatus.occupiedSpots : this.noData}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="empty-data">
          Brak informacji o aktualnej zajętości.
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';

const TemplateModalParkingGroup: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalParkingGroup',
  setup(props) {
    const { noData } = ModalTemplateService;
    const descriptionTop = ref('');
    const category = ref('');
    const parkingSpots = ref(-1);
    const lastStatus: Ref<any> = ref({});
    const hasSpots = ref('');

    onMounted(() => {
      const { metaData } = props.templateData;

      descriptionTop.value = metaData.description;
      category.value = metaData.categories;
      parkingSpots.value = metaData.parkingSpots;
      lastStatus.value = metaData.last_status;
      hasSpots.value = lastStatus.value
        && lastStatus.value.occupiedSpots
        && parkingSpots.value
        ? 'parking-data--has-data'
        : 'parking-data--empty-data';
    });

    return {
      descriptionTop,
      category,
      parkingSpots,
      lastStatus,
      hasSpots,
      noData,
    };
  },
});
export default TemplateModalParkingGroup;
</script>
